import { Box, VStack } from '@chakra-ui/react';
import { IBook } from '@partiu/api/types';
import { Book } from './Book';

interface BookCardProps {
  book: IBook;
  grid?: boolean;
  receivedBook?: boolean;
  isActive: boolean;
  showBestSellersTag?: boolean;
  deliveryCode?: string;
  bestSellerName?: string;
  showEditorialCode?: boolean;
  monthReference?: number;
  yearReference?: number;
}
export function BookCard({
  bestSellerName,
  showBestSellersTag,
  receivedBook,
  book,
  grid,
  isActive,
  deliveryCode,
  showEditorialCode,
  monthReference,
  yearReference,
}: BookCardProps) {
  book.isBestSeller = false;
  if (showBestSellersTag) {
    book.isBestSeller = true;
  }

  return (
    <Box
      width={{
        base: grid ? '100%' : '85%',
        md: grid ? '100%' : '90%',
      }}
      margin={'auto'}
      padding={{
        base: grid ? '1px' : '40px 0px',
        md: grid ? '5px' : '30px 0px',
      }}
    >
      <VStack
        borderRadius={'10px'}
        align={'flex-start'}
        backgroundColor={'white'}
        width={'100%'}
        border="1px solid #ededed"
        padding="8px"
        boxShadow={'rgba(100, 100, 111, 0.2) 0px 5px 8px 0px'}
        transition="transform 0.5s ease-in-out"
        transform={{
          base: isActive ? 'scale(1.15)' : 'scale(1)',
          md: isActive ? 'scale(1)' : 'scale(1)',
        }}
        _hover={{ transform: 'scale(1.15)' }}
      >
        <Book
          bestSellerName={bestSellerName}
          receivedBook={receivedBook}
          book={book}
          deliveryCode={deliveryCode}
          showEditorialCode={showEditorialCode}
          monthReference={monthReference}
          yearReference={yearReference}
        />
      </VStack>
    </Box>
  );
}
